var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1278 -430)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1278 430)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1304.998 456)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.009 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.811 52.521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,369.7a2.27,2.27,0,0,0,4.541,0V347H382Z",
    transform: "translate(-382 -347)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.218,257H339.27a2.27,2.27,0,1,0,0,4.541h2.27v2.27a2.271,2.271,0,0,0,2.27,2.27h17.407a2.271,2.271,0,0,0,2.27-2.27V259.27A2.271,2.271,0,0,0,361.218,257Z",
    transform: "translate(-337 -218.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.541,29.061h-2.27A2.27,2.27,0,0,1,352,26.79V2.27A2.27,2.27,0,0,1,354.27,0h2.27a6.819,6.819,0,0,1,6.811,6.811V22.25A6.819,6.819,0,0,1,356.541,29.061Z",
    transform: "translate(-349.729 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.43 23.508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.065,160.112a2.269,2.269,0,0,0-.665-1.605l-3.19-3.19a11.276,11.276,0,0,1-1.662,4.76l.977.977v5.114h4.541Z",
    transform: "translate(-445.548 -155.316)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 9.385)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.784,
    cy: 3.784,
    rx: 3.784,
    ry: 3.784,
    transform: "translate(12.487 48.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.271,297a16.271,16.271,0,1,0,16.271,16.271A16.29,16.29,0,0,0,16.271,297Zm0,24.6a8.325,8.325,0,1,1,8.325-8.325A8.334,8.334,0,0,1,16.271,321.6Z",
    transform: "translate(0 -261.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.433,74.865a6.433,6.433,0,1,1,6.433-6.433A6.44,6.44,0,0,1,141.433,74.865Z",
    transform: "translate(-114.566 -62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.947 31.785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.086,332h-8.806a20.684,20.684,0,0,1,2.7,6.726,8.3,8.3,0,0,1,2.707,6.14V354.7a4.541,4.541,0,0,0,9.082,0v-9.838A17.36,17.36,0,0,0,233.086,332Z",
    transform: "translate(-224.281 -332)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.991,172.369h12.253a4.541,4.541,0,1,0,0-9.082H113.622v-8.325a6.821,6.821,0,0,0-.2-1.644,10.962,10.962,0,0,1-10.315-4.07A6.8,6.8,0,0,0,100,154.963V167.1q.564-.031,1.135-.031A20.727,20.727,0,0,1,114.991,172.369Z",
    transform: "translate(-84.864 -145.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.011,128.1A6.8,6.8,0,0,0,4.237,122H2.27a2.27,2.27,0,1,0,0,4.541H4.237a2.265,2.265,0,0,1,2.258,2.033l1.786,16.969a20.638,20.638,0,0,1,4.43-1.29Z",
    transform: "translate(0 -122)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType11);
export default __webpack_public_path__ + "static/media/aioa-icon-type-11.284a366111e9d9e8c620c6158ee8da1f.svg";
export { ForwardRef as ReactComponent };